<template>
  <f7-page name="confirm">
    <f7-navbar title="Подтверждение записи" back-link></f7-navbar>
    <f7-block-title>Выбранные услуги</f7-block-title>

    <f7-list id="confirmData" media-list>
      <f7-list-item
        v-for="(cost, index) in costs.data"
        :key="index"
        :title="cost.attributes.title"
        :subtitle="discount(cost)"
        :after="price(cost.attributes.total)"
      ></f7-list-item>
      <f7-list-item :title="title_cost" :after="price(total_cost)">
        <f7-icon slot="media" material="add_shopping_cart"></f7-icon>
      </f7-list-item>
      <f7-list-item
        title="Время выполнения"
        :after="`~` + total_time + ` мин.`"
      ></f7-list-item>
      <f7-list-input
        label="Дата записи"
        type="datepicker"
        name="date"
        :value="selectedDate"
        @input="selectedDate = $event.target.value"
        @calendar:change="selectDay"
        placeholder="дата"
        :calendar-params="calendar"
        error-message="Выберите дату"
        @focus="errorDate = false"
        :error-message-force="errorDate"
      ></f7-list-input>
      <f7-list-input
        label="Время записи"
        name="time"
        type="select"
        placeholder="Выберите время записи..."
        error-message="Выберите время записи"
        @focus="errorTime = false"
        :error-message-force="errorTime"
      >
        <option
          v-for="(time, index) in times"
          :key="index"
          :value="time.attributes.time"
          @input="time.attributes.time = $event.target.value"
        >
          {{ time.attributes.time }}
        </option>
      </f7-list-input>
      <!-- <f7-list-input
        label="Способ оплаты"
        type="select"
        defaultValue="Наличными"
        placeholder="Выберите способ оплаты..."
      >
        <option value="nal">Наличными</option>
        <option value="bill">Со счета BILL</option>
      </f7-list-input>-->
    </f7-list>

    <f7-block>
      <f7-row tag="p">
        <f7-button round class="col" @click="checkForm()" raised fill
          >Записаться</f7-button
        >
        <f7-button round class="col" href="/" raised>Отмена</f7-button>
      </f7-row>
    </f7-block>
  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      selectedDate: "",
      errorDate: false,
      errorTime: false,
      costs: "",
      total_cost: 0,
      total_time: 0,
      title_cost: "Стоимость",
      order: JSON.parse(localStorage.getItem("order")),
      times: [
        {
          type: "times",
          id: 0,
          attributes: {
            time: "время",
          },
        },
        {
          type: "times",
          id: 0,
          attributes: {
            time: "На этот день нет записи",
          },
        },
      ],
      calendar: {
        openIn: "customModal",
        locale: "ru",
        headerPlaceholder: "Дата",
        toolbarCloseText: "Выбрать",
        header: true,
        footer: true,
        touchMove: this.$f7ready((f7) => {
          return !f7.device.desktop;
        }),
        dateFormat: "dd.mm.yyyy г.",
        disabled: function (date) {
          var dd = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
          var m = date.getMonth() + 1;
          var mm = m <= 9 ? "0" + m : m;
          var day = date.getFullYear() + "-" + mm + "-" + dd;
          var days = JSON.parse(localStorage.getItem("days"));
          return days.indexOf(day) == -1 ? true : false;
        },
      },
    };
  },
  methods: {
    checkForm() {
      var errors = [];
      var formData = this.$f7.form.convertToData("#confirmData");
      console.log(formData);

      if (formData.date == "") {
        this.errorDate = true;
        errors.push("errorDate");
        return false;
      }

      if (formData.time == "время") {
        this.errorTime = true;
        errors.push("errorTime");
        return false;
      }

      var datetime = JSON.parse(localStorage.getItem("datetime"));
      var user = JSON.parse(localStorage.getItem("user"));
      var order = JSON.parse(localStorage.getItem("order"));
      var garage = JSON.parse(localStorage.getItem("garage"));

      var dataOrder = {
        data: [
          {
            type: "orders",
            id: "1",
            attributes: {
              day: datetime.date,
              time: formData.time,
            },
            relationships: {
              users: {
                data: {
                  type: "users",
                  id: "0",
                },
              },
              services: {
                data: [],
              },
            },
          },
        ],
        included: [
          {
            type: "users",
            id: "0",
            attributes: {
              name: user.name,
              phone: parseInt(user.phone.replace(/\D+/g, "")),
              email: user.email,
            },
            relationships: {
              cars: {
                data: {
                  type: "cars",
                  id: order.car.id,
                },
              },
            },
          },
          {
            type: "cars",
            id: order.car.id,
            attributes: {
              carBrand: order.car.attributes.carBrand,
              stateNumber: order.car.attributes.stateNumber,
              category: order.car.attributes.category,
              color: order.car.attributes.color,
            },
          },
        ],
      };
      var i = 0;
      order.services.forEach(function (id) {
        dataOrder.data[0].relationships.services.data[i] = {
          type: "services",
          id: id,
        };
        i++;
      });
      console.log(dataOrder);
      this.api(dataOrder);
    },
    discount(cost) {
      if (cost.attributes.discount > 0) {
        this.title_cost = "Стоимость со скидкой";
        return (
          cost.attributes.price +
          ` ₽ - ` +
          cost.attributes.discount +
          `% скидка`
        );
      }
    },
    price(price) {
      return parseInt(price).toLocaleString("ru-RU") + ` ₽`;
    },
    calculation() {
      this.$f7ready((f7) => {
        let that = this;
        let order = that.order;
        let getData = {
          filter: {
            services: order.services.toString(),
          },
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/costs",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              that.costs = data;
              data.data.forEach(function (calc) {
                that.total_cost += parseInt(calc.attributes.total);
                that.total_time += parseInt(calc.attributes.duration);
              });
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    selectDay(e) {
      let date = new Date(e);
      var dd = date.getDate() <= 9 ? "0" + date.getDate() : date.getDate();
      var m = date.getMonth() + 1;
      var mm = m <= 9 ? "0" + m : m;
      var day = date.getFullYear() + "-" + mm + "-" + dd;
      console.log(day);
      localStorage.setItem("datetime", `{"date": "${day}"}`);
      this.getTimes(day);
    },
    api(post) {
      this.$f7ready((f7) => {
        let that = this;
        let order = that.order;
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/orders",
          method: "POST",
          dataType: "json",
          data: JSON.stringify(post),
          success: function (data, status) {
            if (data.data != null) {
              console.log("Список заявок.");
              var toast = f7.toast.create({
                icon: '<i class="f7-icons">checkmark_seal</i>',
                text: `Заказ принят.`,
                position: "center",
                closeTimeout: 4000,
              });
              toast.open();
              that.$f7.views.main.router.navigate("/history/");
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                    if (error.detail == "Указанное время записи занято!") {
                      var datetime = JSON.parse(
                        localStorage.getItem("datetime")
                      );
                      that.getTimes(datetime.date);
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    getDays() {
      this.$f7ready((f7) => {
        let that = this;
        let days = [];
        let order = that.order;
        let getData = {
          filter: {
            services: order.services.toString(),
          },
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/dates",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              data.data.forEach(function (e) {
                days.push(e.attributes.date);
              });
              localStorage.setItem("days", JSON.stringify(days));
              return true;
            } else {
              f7.dialog.alert(
                "Нет свободных дней доступных для записи.",
                "Ошибка"
              );
              return false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    getTimes(day) {
      let sday = day;
      this.$f7ready((f7) => {
        let that = this;
        let getData = {
          filter: {
            day: sday,
            services: that.order.services.toString(),
          },
        };
        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/times",
          method: "GET",
          dataType: "json",
          data: getData,
          success: function (data, status) {
            if (data.data != null) {
              that.times = data.data;
              return true;
            } else {
              f7.dialog.alert(
                "Нет свободных дней доступных для записи.",
                "Ошибка"
              );
              return false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(error.detail, "Ошибка " + error.status);
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
  },
  mounted: function () {
    this.getDays();
    this.calculation();
  },
};
</script>
